import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";
import { useNavigate } from 'react-router-dom';


export default function PopularCruiseLines() {
    const navigate = useNavigate();
    const [data, setData] = useState([]);

    useEffect(() => {
        apiRequest({ url: "/cruise-lines?category=Popular" })
            .then((res) => {
                if (res.success) {
                    setData(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
            });
    }, []);

    return (
        <div className='container-fluid pt-5'>
            <div className="container py-5 text-center">
                <div className="mx-auto text-center mb-5" >
                    <h5 className="section-title px-3">Cruise</h5>
                    <h1 className="mb-0">Popular Cruise Lines</h1>
                </div>
                <div className="d-flex flex-wrap justify-content-center gap-4">
                    {data.map((line) => (
                        <div key={line.id} className="cruise-card" 
                            onClick={() => navigate(`/cruise/${line.slug}`, { state: line.id })}
                        >
                            <div className="card d-flex align-items-center justify-content-center p-3 rounded shadow">
                                <img
                                    src={line.logo}
                                    alt={line.name}
                                    className="cruise-logo"
                                />
                                {/* <h6 className="mt-2 mb-0">{line.name}</h6> */}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
